/* eslint-disable no-useless-escape */
import React,{Fragment} from 'react'
import { NavLink, withRouter} from 'react-router-dom'
import withAuthLayout from 'components/layouts/withAuthLayout';
import {ReactComponent as Logo } from  'assets/images/svg/logo.svg';
import { Formik } from 'formik';
import Swal from 'sweetalert2'



const ForgotPassword = props => { 
    const {history} = props;

 return (
    <Fragment>
        <div className="row">
            <div className="w-100">
                <div className="d-flex flex-row justify-content-center">
                    <Logo className="mx-auto"/>
                </div>
            </div>
            <div className="col-md-6 mx-auto">
                <div className="auth-login__main">
                    <h2 className="auth-login__main-header">Forget Password</h2>
                    <p className="auth-login__main-info">Enter your email address linked to your account and we will email / sms
                    you instructions to reset your password</p>

                    <div className="mt-3">
                        <Formik 
                            initialValues={{email: ''}}
                            validate={ (values) => {
                                let errors = {}
                                const regexp = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
                                if (!values.email ||  !regexp.test(values.email)){
                                    errors.email = true
                                }
                                return errors;
                            
                            }}
                            onSubmit={(values,{isSubmitting, setSubmitting}) => {
                                setSubmitting(true)
                                fetch('https://musicandrights.herokuapp.com/api/v1/forgot_password',{
                                    method: 'POST',
                                    headers: {'Content-Type': 'application/json'},
                                    body: JSON.stringify(values)
                                })
                                .then(res => res.json())
                                .then(res => {
                                    setSubmitting(false)
                                    // console.log(res)
                                    if(res.code === 200){
                                        Swal.fire({
                                            type: 'success',
                                            title: 'Forgot Password',
                                            text: res.data.message,
                                            onOpen: () => {
                                                setTimeout( () => {
                                                    Swal.clickConfirm()
                                                    history.push('/login')
                                                }, 2000)
                                            }
                                        }).then((confirm) => {
                                            if(confirm) {
                                                history.push('/login')
                                            }
                                        })
                                        
                                    }
                                    if (res.code === 400) {
                                        Swal.fire({
                                            type: 'error',
                                            title: 'Error ocurred',
                                            text: res.message
                                        })
                                    }     
                                })
                                .catch(err => {
                                    setSubmitting(false)
                                    // console.log(err)
                                })

                            }}>
                                {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                /* and other goodies */
                                }) => (
                                    <form onSubmit={handleSubmit}>
                                        <div>
                                            <label className="nsForm-label">email address</label>
                                            <input name="email" 
                                                className={`nsForm-input ${ touched.email && errors.email ? 'error': null}`}
                                                type="email" placeholder="Enter your Email address" 
                                                onChange={handleChange}/>
                                        </div>
                                        <button type="submit" 
                                            className="pill pill--secondary mt-3" 
                                            disabled={isSubmitting}>
                                                <p>{isSubmitting ? 'Sending Link..' : 'Send Link' }</p>
                                        </button>
                                    </form>
                                )}

                        </Formik>
                        
                    </div>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-5 mx-auto">
                <div className="pill pill--whitesmoke mt-4">
                    <p>Already have an account? <NavLink to="/login" className="auth__link">Sign in</NavLink>.</p>
                </div>
            </div>
        </div>
    </Fragment>
)}

export default withAuthLayout(withRouter(ForgotPassword), {});